import 'svgxuse';
import regularPage from './pages/regular';

import {$dom} from './helpers/dom';

import {isElement} from './helpers/_utilities';

const pages = [
	regularPage
];

$dom.ready(function() {
	this.currentPage = pages.find(page => isElement(page.rootEl));

	if (Boolean(this.currentPage)) this.currentPage.init()
});
